import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  DateField,
  Labeled,
  RecordContextProvider,
  ReferenceField,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import dataProvider from "server/dataProvider";
import { ATTESTATIONS, GraduationServicePath, MONTHLY_INTERNSHIP } from "utils/constants";
import { graduationRequests } from "api/graduationApi";
import StartMonthlyInternshipDialog from "./StartMonthlyInternshipDialog";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import ApprovalIcon from "@mui/icons-material/Approval";
import { useNavigate } from "react-router";

const MonthlyInternshipData = ({ studentEducationId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const [monthlyInternship, setMonthlyInternship] = useState({});
  const [isMonthlyInternshipStarted, setIsMonthlyInternshipStarted] = useState(null);

  const fetchMonthlyInternship = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        graduationRequests.getStudentMonthlyInternship(studentEducationId),
      );
      setMonthlyInternship(data);
      setIsMonthlyInternshipStarted(true);
    } catch (err) {
      if (err?.status === 404) {
        setIsMonthlyInternshipStarted(false);
      } else {
        console.error(err);
      }
    }
  }, [studentEducationId]);

  useEffect(() => {
    if (!studentEducationId) return;
    fetchMonthlyInternship();
  }, [studentEducationId, fetchMonthlyInternship]);

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {!isMonthlyInternshipStarted ? (
          <SecuredComponent permission={permissions.canManageMonthlyInternshipStart}>
            <StartMonthlyInternshipDialog
              studentEducationId={studentEducationId}
              fetchMonthlyInternship={fetchMonthlyInternship}
              isMonthlyInternshipStarted={isMonthlyInternshipStarted}
            />
          </SecuredComponent>
        ) : (
          <RecordContextProvider value={monthlyInternship}>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Дата на започване">
                <DateField
                  source="startDate"
                  locales="bg-BG"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Тип локация">
                <ReferenceField
                  source="locationType"
                  reference={graduationRequests.getStudentMonthlyInternshipLocationTypesSelect()}
                >
                  <TextField source="nameBg" />
                </ReferenceField>
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Име на локация">
                <TextField source="locationName" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Адрес на локация">
                <TextField source="locationAddress" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Ръководител">
                <TextField source="supervisor" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <SecuredComponent permission={permissions.canManageMonthlyInternshipStart}>
                <StartMonthlyInternshipDialog
                  studentEducationId={studentEducationId}
                  fetchMonthlyInternship={fetchMonthlyInternship}
                  isMonthlyInternshipStarted={isMonthlyInternshipStarted}
                />
              </SecuredComponent>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <SecuredComponent permission={permissions.canPreviewMonthlyInternshipAttestations}>
                <Button
                  label="Заверки за месечен стаж"
                  startIcon={<ApprovalIcon />}
                  variant="contained"
                  onClick={() =>
                    navigate(`/${GraduationServicePath}${MONTHLY_INTERNSHIP}/${ATTESTATIONS}/${studentEducationId}`, {
                      state: { startDate: monthlyInternship.startDate },
                    })
                  }
                />
              </SecuredComponent>
            </Grid>
          </RecordContextProvider>
        )}
      </Grid>
    </SimpleShowLayout>
  );
};

export default MonthlyInternshipData;
